// extracted by mini-css-extract-plugin
export default {"center":"DownloadSoftwareBundle_center__WeBao"};